import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3c03fc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapse-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PanelMenu = _resolveComponent("PanelMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-menu pt-3", { 'collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        class: "menu-collapse-icon",
        onClick: _ctx.toggleCollapse
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_PanelMenu, {
      expandedKeys: _ctx.expandedKeys,
      "onUpdate:expandedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedKeys) = $event)),
      model: _ctx.items,
      router: true
    }, null, 8, ["expandedKeys", "model"])
  ], 2))
}